/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsProjectIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsProjectIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectIdQueryOperator>): AppSecopsProjectIdQueryOperator {
        let obj = Object.assign(new AppSecopsProjectIdQueryOperator(), model);
        AppSecopsProjectIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectIdQueryOperator>): AppSecopsProjectIdQueryOperator {
        if (!model) return null;
        return AppSecopsProjectIdQueryOperator.newInstance(<AppSecopsProjectIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsProjectIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsProjectIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Appsecops project IDs to include
     */
    appsecops_project_ids: Array<string>;

}
